var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "content-icons-ui": "static-1.2146"
    },
    "depPathPrefixes": {
      "content-icons-ui": "/content-icons-ui/static-1.2146"
    },
    "bundlingPackage": "page-editor-ui",
    "bundlingPackageVersion": "static-1.37662",
    "project": "content-icons-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};